class ScrollState {
  constructor() {
    this.x = 0
    this.y = 0
  }

  set(axis, value) {
    if (axis || value || value === 0) {
      this[axis] = value
    }
  }

  get(axis) {
    return axis ? this[axis] : null
  }
}

const scrollState = new ScrollState()

export { scrollState }
